import React, { useEffect, useReducer, useState} from 'react';
import {Container, Row,Button, Nav, Accordion} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import "../stylesheets/style.css"
import "../js/main.js"
import Testimonials from './Testimonials';
import Faq from './Faq';
import Contact from './Contact'
import Subscribe from './Subscribe';
const Blogpost2 = () => {
    useEffect(() =>{
        document.title = "An Early Christmas Gift For You"
    },[])

    const [RotateDg, setRotateDg] = useState()  

    const rotateDgCSS = {
        transform: "rotate(-25deg)",
        transition: "transform 0.2s ease 0s"
      }

      const removerotateDgCSS = {
        transform: "rotate(0deg)",
        transition: "transform 0.2s ease 0s"
      }

      const rotatedg = () =>{
        setRotateDg(rotateDgCSS) 
    }
    const stoprotatedg = () =>{
        setRotateDg(removerotateDgCSS) 
    }



    return (
      
      <div>
<div className="homepageslider" id="homepageslider">
<Header/>

<div  class="apartmentsfirstbox">
<div class="container">

<h3 className="blogherotitle">An Early Christmas Gift For You
   
   </h3>

   
<div class="row blogotherdets">

{/* <p className="blogdetails"> <img src="images/icons/calendar.png"/> 24 Jan, 2021</p>
    <p className="blogdetails"> <img src="images/icons/clock2.png"/> 4 mins, 23 secs read</p> */}


    {/* <div class="col-md-4">
    <p> <img src="images/icons/calendar.png"/> 24 Jan, 2021 <img style={{marginLeft:"10px"}} src="images/icons/clock2.png"/> 4 mins, 23 secs read</p>
        </div> */}

    </div>


   <div class="row">
<div class="col-md-12">
<img className="img-fluid" src="images/blog/blogpost1.png"/>

</div>


</div>






<div class="row blogbodycontent">

<div class="col-md-12">
<p className="blogcontent"><strong><em>&quot;The house you looked at today and wanted to think about until tomorrow, may be the same house someone looked at yesterday and will buy today.&rdquo;</em></strong></p>
<p className="blogcontent"><strong><em>&ndash;Koki Adasi</em></strong></p>
<p className="blogcontent">We bring you glad tidings this yuletide season and we are not even Santa. Our long awaited masterpiece is ready!</p>
<p className="blogcontent">Oak Grandeur II, the definition of excellence and luxury befitting people with impeccable taste for the finest things of life is on sale.</p>
<p className="blogcontent">We designed &nbsp;these 3-Bedroom apartment units to perfection. Located in the serene and secure area of Jahi, Oak Grandeur II is everything you would need and more.</p>
<p className="blogcontent">The units are fast-selling and we know exactly why. With a strong whiff of sophistication, Oak Grandeur II is dipped in the latest technology and sculpted by qualified hands to meet your grand needs for space, security and comfort. Don&apos;t sleep on this.</p>
<p className="blogcontent">Early birds who can&apos;t wait till 1st September, 2022 for completion of the project can get our semi-finished Smart home for an outright payment of 35,000,000 or spread the sum of 38,150,000 across 12 months. You deserve a slice of luxury and smart living, that&apos;s what we are offering this season of love.</p>
<p className="blogcontent">What&apos;s more? Our Oak Grandeur II edifice has great rental value which can accumulate a lifetime of passive income in case you are not interested in buying a home for your personal use.</p>
<p className="blogcontent">There&apos;s something for everyone!</p>
<p className="blogcontent">Our Customers are important to us so we put every budget into consideration by putting the power of choice in your hand. Choose from either semi-finished, semi-finished semi smart or fully finished, fully Smart home options.</p>
<p className="blogcontent">Make that decision to buy any of our units at different stages of completion today. &nbsp;</p>
<p className="blogcontent" >Contact us for more information or schedule a site visit on 09016854815</p>
    </div>


</div>


    </div>

    </div>









    </div>



    <Subscribe/>


    <Footer/>
    </div>


    )
    
    
}


export {Blogpost2 as default}